import { Stack, Typography } from "@mui/material";
import { Alert } from "Components/_Shared/Alert";
import { Flex } from "Components/_Shared/Core/Flex";
import { Spacing } from "Infrastructure/Themes/Themes";
import { type ResourcePathType, Resources, useResource } from "Infrastructure/Translations/Resources";

type SidebarContent = {
  items: Array<{ title: string; description: string }>;
};

const getSidebarContent = (t: (resource: ResourcePathType, options?: any) => string): SidebarContent[] => [
  {
    items: [
      {
        title: t(Resources.Questionnaire.Sidebar.RiskTolerance.Title),
        description: t(Resources.Questionnaire.Sidebar.RiskTolerance.Description),
      },
      {
        title: t(Resources.Questionnaire.Sidebar.LossCapability.Title),
        description: t(Resources.Questionnaire.Sidebar.LossCapability.Description),
      },
      {
        title: t(Resources.Questionnaire.Sidebar.InvestmentPreference.Title),
        description: t(Resources.Questionnaire.Sidebar.InvestmentPreference.Description),
      },
    ],
  },
  {
    items: [
      {
        title: t(Resources.Questionnaire.Sidebar.FinancialBackground.Title),
        description: t(Resources.Questionnaire.Sidebar.FinancialBackground.Description),
      },
    ],
  },
  {
    items: [
      {
        title: t(Resources.Questionnaire.Sidebar.KnowledgeTest.Title),
        description: t(Resources.Questionnaire.Sidebar.KnowledgeTest.Description),
      },
      {
        title: t(Resources.Questionnaire.Sidebar.ExperienceTest.Title),
        description: t(Resources.Questionnaire.Sidebar.ExperienceTest.Description),
      },
    ],
  },
  {
    items: [
      {
        title: t(Resources.Questionnaire.Sidebar.EsgPreferences.Title),
        description: t(Resources.Questionnaire.Sidebar.EsgPreferences.Description),
      },
    ],
  },
];

type Props = {
  stepIndex: number;
};

export const QuestionnaireSidebar = ({ stepIndex }: Props) => {
  const { t } = useResource();
  const sidebarContent = getSidebarContent(t);
  const content = sidebarContent[stepIndex] ?? null;

  if (!content) return null;

  return (
    <Flex sx={{ width: "350px", flexShrink: 0, alignSelf: "flex-start" }} px={Spacing.XL}>
      <Alert
        variant="gray"
        content={
          <Stack spacing={Spacing.M} pt={Spacing.S}>
            <Stack spacing={Spacing.XL}>
              {content.items.map((item) => (
                <Stack key={item.title} spacing={Spacing.S}>
                  <Typography variant="body2" fontWeight={500}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" fontWeight={300}>
                    {item.description}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        }
      />
    </Flex>
  );
};
